import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as selectors from '../redux/selectors';
import * as actions from '../redux/counter/actions';

import Logo from '../components/Logo';

import './Home.css';

class Home extends Component {
  static propTypes = {
    counters: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
  }

  static defaultProps = {
    counters: [],
  }

  static contextTypes = {
    store: PropTypes.object,
  }

  static mapStateToProps = state => ({
    counters: selectors.getListCounter(state),
    loading: selectors.getListCounterLoading(state),
  })

  constructor(props) {
    super(props);
    this.state = {
      items: props.counters,
      loading: props.loading,
    }
  }

  async componentDidMount() {
    const { store } = this.context;
    await store.dispatch(actions.getListCounter());
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.counters !== this.props.counters) {
      this.setState({ items: nextProps.counters});
    }
  }

  renderData = (data) => {
    const { counters, loading } = this.props;
    if (loading) return <Logo small spin />;
    if (counters[data] || counters[data] === 0) {
      return counters[data];
    }
    if (data === 'checkCount') {
      return '-'
    }
    return <Logo small spin />;
  }

  renderMonthly = (data) =>{
    const { counters } = this.props;
    if (counters === undefined || counters.length === 0) return '-';
    console.log(counters);
    return 'test';
  }

  handleUpdate = async () => {
    const { store } = this.context;
    await store.dispatch(actions.getListCounter());
  }

  render() {
    const { counters, loading } = this.props;
    if (counters === undefined || counters.length === 0 || loading) return <Logo small spin />;
    return (
      <div className="Home">
        <h3>Dashboard</h3>
        <div className="wrapper">
          <div className="subHeader">
            <div>
              <button onClick={this.handleUpdate}>
              {loading ? 'Updating..' : 'Refresh'}
              </button>
            </div>
          </div>

          <div className="boxWrapper">
            <div className="box">
              <p>Credit Checks</p>
              <h2>{this.renderData('successChecks')}</h2>
            </div>

            <div className="box">
              <p>Bad DSR</p>
              <h2>{this.renderData('BadDsr')}</h2>
            </div>

            <div className="box">
              <p>Good DSR</p>
              <h2>{this.renderData('GoodDsr')}</h2>
            </div>

            <div className="box">
              <p>Total User</p>
              <h2>{this.renderData('totalUser')}</h2>
            </div>

            <div className="box">
              <p>Total Leads</p>
              <h2>{this.renderData('totalLeads')}</h2>
            </div>

            <div className="box">
              <p>Agreed TnC</p>
              <h2>{this.renderData('agreeTnc')}</h2>
            </div>

            <div className="box">
              <p>Uploaded MyKad</p>
              <h2>{this.renderData('uploadMykad')}</h2>
            </div>

            <div className="box">
              <p>Verified MyKad</p>
              <h2>{this.renderData('verifiedIC')}</h2>
            </div>

            <div className="box">
              <p>Verified Mobile</p>
              <h2>{this.renderData('verifiedMobile')}</h2>
            </div>

            <div className="box">
              <p>Submitted Income</p>
              <h2>{this.renderData('hasIncome')}</h2>
            </div>
          </div>
          <hr />
          {
            [].concat(counters.monthly).map((m) => {
              if (loading) return <Logo small spin />;
              return (
                <div className="boxWrapper" key={m.month}>
                  <div className="subHeader">
                    <h4>{m.month}</h4>
                  </div>
                  <div className="box">
                    <h2>{m.data.totalUser}</h2>
                    <p>Users Added</p>
                  </div>
                  <div className="box">
                    <h2>{m.data.successChecks}</h2>
                    <p>Credit Checks</p>
                  </div>
                  <div className="box">
                    <h2>{m.data.totalLeads}</h2>
                    <p>Leads Submitted</p>
                  </div>
                </div>
              )
            })
          }
          
        </div>
      </div>
    );
  }
}

export default connect(Home.mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.jsx